import { useEffect, useState } from 'react';
import { useMap } from '@vis.gl/react-google-maps';

export const TrafficLayer = ({ visible }: { visible: boolean }) => {
  const map = useMap();
  const [trafficLayer, setTrafficLayer] = useState<google.maps.TrafficLayer | null>(null);

  useEffect(() => {
    if (!map || typeof google === 'undefined') return;

    const layer = new google.maps.TrafficLayer();
    setTrafficLayer(layer);

    return () => {
      layer.setMap(null);
    };
  }, [map]);

  useEffect(() => {
    if (!trafficLayer) return;

    trafficLayer.setMap(visible ? map : null);
  }, [visible, trafficLayer, map]);

  return null;
};
